<template>
	<div :class="toogleAside ? 'toggled' : ''" id="dashboard">
		<!-- <b-button class="btn-language" variant="link" @click="showLanguageModal = true">
			<i class="fa fa-language" aria-hidden="true"></i> {{ $t('Language') }}
		</b-button> -->
		<b-modal
			size="sm"
			hide-footer
			v-model="showLanguageModal"
			:title="$t('Select language')"
		>
			<a
				v-for="[lng, label] in LANGUAGES"
				:key="lng"
				class="d-block m-auto"
				href="#"
				@click="changeLang(lng)"
			>
				{{ label }}
			</a>
		</b-modal>

		<aside class="no-print">
			<button @click="toogleAside = !toogleAside" class="btn btn-default logo">
				<img src="../../assets/logo_en_sm.svg" alt="" />
			</button>
			<h4>{{ 'Management' | translate }}</h4>
			<router-link
				v-if="roleToNumber === 6"
				:to="{ name: 'Dashboard List', params: { role: 'master franchise' } }"
			>
				{{ 'Master Franchise' | translate }}
			</router-link>
			<router-link
				v-if="roleToNumber >= 5"
				:to="{ name: 'Dashboard List', params: { role: 'franchise' } }"
			>
				{{ 'Franchise' | translate }}
			</router-link>
			<router-link
				v-if="roleToNumber >= 4"
				:to="{ name: 'Dashboard List', params: { role: 'teacher' } }"
			>
				{{ 'Teachers' | translate }}
			</router-link>
			<router-link
				v-if="roleToNumber >= 3"
				:to="{ name: 'Dashboard List', params: { role: 'group' } }"
			>
				{{ 'Groups' | translate }}
			</router-link>
			<router-link
				:to="{ name: 'Dashboard List', params: { role: 'student' } }"
			>
				{{ 'Students' | translate }}
			</router-link>
			<!-- <router-link
				class="text-danger "
				:to="{
					name: 'Dashboard Deactivated List',
					params: { role: 'student', type: 'deactivated' },
				}"
				>{{ 'disableStudent.list' | translate }}</router-link
			> -->
			<router-link :to="{ name: 'Dashboard List', params: { role: 'parent' } }">
				{{ 'Parents' | translate }}
			</router-link>
			<hr />
			<router-link
				v-if="roleToNumber >= 4"
				:to="{ name: 'Dashboard Reports', params: { id: 'me' } }"
			>
				{{ 'Finance' | translate }}
			</router-link>
			<router-link v-if="roleToNumber >= 3" to="/dashboard/restore">
				{{ 'Restore' | translate }}
				<!-- <span	class="new">new</span> -->
			</router-link>
			<router-link v-if="roleToNumber >= 4" to="/dashboard/lessons">
				{{ 'Lessons' | translate }}
			</router-link>
			<router-link to="/dashboard/storage">
				{{ 'Materials' | translate }}
			</router-link>
			<router-link v-if="role === 'super franchise'" to="/dashboard/settings">
				{{ 'Settings' | translate }}
			</router-link>
			<hr />
			<h4>{{ 'Pages' | translate }}</h4>
			<router-link to="/faq">FAQ</router-link>
			<router-link to="/franchise">
				{{ 'Become franchise' | translate }}
			</router-link>
			<router-link to="/contact_us">
				{{ 'Contact us' | translate }}
			</router-link>
			<router-link to="/press">{{ 'Press' | translate }}</router-link>
			<router-link to="/terms">{{ 'Terms of Use' | translate }}</router-link>
			<router-link to="/privacy">
				{{ 'Privacy Policy' | translate }}
			</router-link>
			<router-link to="/jobs">{{ 'Jobs' | translate }}</router-link>
			<router-link to="/company">{{ 'Company' | translate }}</router-link>
			<router-link to="/about">{{ 'About Us' | translate }}</router-link>
			<router-link to="/public_contract">
				{{ 'Learning contract' | translate }}
			</router-link>
			<router-link to="/games">{{ 'Training' | translate }}</router-link>
			<hr />
			<a href="#" @click.prevent="logOut">{{ 'Logout' | translate }}</a>
			<template v-if="roleToNumber === 6">
				<hr />
				<button
					class="btn btn-link text-danger"
					v-if="!loadingRestoreHierarchy"
					@click="restoreHierarchy"
				>
					{{ 'Restore Hierarchy' | translate }}
				</button>
				<span v-else class="loading">
					In progress...
					<i class="fa fa-spinner fa-pulse" />
				</span>
			</template>
		</aside>
		<div id="dashboard-content">
			<div class="dashboard-main-page">
				<header class="dashboard-header">
					<div class="container-fluid">
						<div class="row">
							<div class="col-container">
								<div class="col-left">
									<button
										@click="toogleAside = !toogleAside"
										style="background: transparent"
										class="btn-hover btn-menu"
									>
										<i class="fa fa-bars" aria-hidden="true" />
										<span>menu</span>
									</button>
									<a class="btn-hover btn-back" @click.prevent="$router.go(-1)">
										<i class="fa fa-arrow-left" aria-hidden="true" />
										{{ 'Back' | translate }}
									</a>
								</div>
								<div class="col-center">
									<h2>{{ dashboardHeader }}</h2>
								</div>
								<div class="col-right">
									<b-button
										class="btn-language"
										variant="link"
										@click="showLanguageModal = true"
									>
										<i class="fa fa-language" aria-hidden="true"></i>
										{{ $t('Language') }}
									</b-button>

									<router-link
										:to="{ name: 'Dashboard Profile', params: { id: 'me' } }"
										class="user btn-hover"
									>
										<svg
											width="10"
											height="12"
											viewBox="0 0 10 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M5.00016 5.33333C5.52758 5.33333 6.04315 5.17694 6.48168 4.88392C6.92021 4.5909 7.26201 4.17443 7.46384 3.68716C7.66568 3.19989 7.71848 2.66371 7.61559 2.14643C7.5127 1.62914 7.25872 1.15399 6.88578 0.78105C6.51284 0.40811 6.03769 0.154134 5.5204 0.0512405C5.00312 -0.0516535 4.46694 0.00115542 3.97967 0.202989C3.4924 0.404823 3.07593 0.746616 2.78291 1.18515C2.48989 1.62368 2.3335 2.13925 2.3335 2.66667C2.3335 3.37391 2.61445 4.05219 3.11454 4.55229C3.61464 5.05238 4.29292 5.33333 5.00016 5.33333ZM5.00016 1.33333C5.26387 1.33333 5.52166 1.41153 5.74092 1.55804C5.96019 1.70455 6.13109 1.91279 6.232 2.15642C6.33292 2.40006 6.35932 2.66815 6.30788 2.92679C6.25643 3.18543 6.12944 3.42301 5.94297 3.60948C5.7565 3.79595 5.51892 3.92294 5.26028 3.97438C5.00164 4.02583 4.73355 3.99942 4.48992 3.89851C4.24628 3.79759 4.03805 3.62669 3.89154 3.40743C3.74503 3.18816 3.66683 2.93038 3.66683 2.66667C3.66683 2.31305 3.80731 1.97391 4.05735 1.72386C4.3074 1.47381 4.64654 1.33333 5.00016 1.33333Z"
												fill="white"
											/>
											<path
												d="M5.00016 6.66675C3.76249 6.66675 2.5755 7.15841 1.70033 8.03358C0.825161 8.90875 0.333496 10.0957 0.333496 11.3334C0.333496 11.5102 0.403734 11.6798 0.528758 11.8048C0.653783 11.9298 0.823352 12.0001 1.00016 12.0001C1.17697 12.0001 1.34654 11.9298 1.47157 11.8048C1.59659 11.6798 1.66683 11.5102 1.66683 11.3334C1.66683 10.4494 2.01802 9.60151 2.64314 8.97639C3.26826 8.35127 4.11611 8.00008 5.00016 8.00008C5.88422 8.00008 6.73206 8.35127 7.35719 8.97639C7.98231 9.60151 8.3335 10.4494 8.3335 11.3334C8.3335 11.5102 8.40373 11.6798 8.52876 11.8048C8.65378 11.9298 8.82335 12.0001 9.00016 12.0001C9.17697 12.0001 9.34654 11.9298 9.47157 11.8048C9.59659 11.6798 9.66683 11.5102 9.66683 11.3334C9.66683 10.0957 9.17516 8.90875 8.29999 8.03358C7.42482 7.15841 6.23784 6.66675 5.00016 6.66675Z"
												fill="white"
											/>
										</svg>

										{{ 'Teacher' | translate }}
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</header>

				<template v-if="error === false">
					<router-view></router-view>
				</template>
				<template v-if="error">
					<h1 class="text-danger text-center">403</h1>
					<h1 class="text-danger text-center">
						{{ 'Access denied' | translate }}
					</h1>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { removeToken } from '../../helpers/token'

export default {
	name: 'dashboard',
	data() {
		return {
			LANGUAGES: [
				['en', 'English'],
				['ru', 'Русский'],
				['ua', 'Українська'],
				['pl', 'Polski'],
				['he', 'עברית'],
				['az', 'Azərbaycan'],
				['ro', 'Română '],
				['hy', 'հայերեն'],
				['fr', 'Français'],
				['es', 'Español'],
				['cs', 'Czech'],
				['de', 'Deutsch'],
				['it', 'Italiano'],
				['tr', 'Türkçe'],
				['el', 'Ελληνικά'],
			],
			showLanguageModal: false,
			toogleAside: false,
			role: this.$store.state.myProfile
				? this.$store.state.myProfile.role
				: JSON.parse(window.localStorage.getItem('userProfile')).role,
			search: '',
			loadingRestoreHierarchy: false,
			error: false,
		}
	},
	beforeCreate() {
		if (this.$store.state.myProfile === null) {
			// Update page for catching localStorage data (users`s profile info and token)
			window.location.href = `${window.location.protocol}//${window.location.host}`
		}
	},
	created() {
		const lng = localStorage.getItem('defaultLanguage') || this.$i18n.locale()
		if (lng) {
			const [key] = lng && lng.split(',')
			if (key) {
				this.lang = key.toUpperCase()
				this.$i18n.set(key)
				if (this.$i18n.locale() !== lng) {
					this.$i18n.set(key)
				}
			}
		} else {
			let browserLng =
				window.navigator.userLanguage || window.navigator.language
			if (browserLng && typeof browserLng === 'string') {
				const [lowerKey, upperKey] = browserLng.split('-')
				if (this.lngKeys.includes(lowerKey)) {
					this.lang = upperKey
					return
				}
				this.lang = 'RU'
				this.$i18n.set('ru')
			}
		}
	},
	methods: {
		changeLang(locale) {
			window.localStorage.setItem('defaultLanguage', locale)
			this.$i18n.set(locale)
			this.showLanguageModal = false
		},
		restoreHierarchy() {
			this.loadingRestoreHierarchy = true
			this.axios({
				method: 'post',
				url: `users/restore-hierarchy`,
			}).then(() => {
				this.loadingRestoreHierarchy = false
			})
		},
		logOut() {
			removeToken()
			window.localStorage.removeItem('userProfile')
			this.$store.state.myProfile = null
			this.$router.push({ path: '/' })
		},
	},
	computed: {
		roleToNumber() {
			switch (this.role) {
				case 'super franchise':
					return 6
				case 'master franchise':
					return 5
				case 'franchise':
					return 4
				case 'teacher':
					return 3
				case 'parent':
					return 2
				case 'student':
					return 1
			}
			return ''
		},
		dashboardHeader() {
			let pageName = this.$route.name
			let pageRole = this.$route.params.role
			if (pageName === undefined) {
				return ''
			} else if (~pageName.indexOf('List')) {
				if (pageRole === 'master franchise') {
					return this.$t('List') + ' - ' + this.$t('Master Franchise')
				} else if (pageRole === 'franchise') {
					return this.$t('List') + ' - ' + this.$t('Franchise')
				} else if (pageRole === 'teacher') {
					return this.$t('List') + ' - ' + this.$t('Teacher')
				} else if (pageRole === 'group') {
					return this.$t('List') + ' - ' + this.$t('Group')
				} else if (pageRole === 'student') {
					return this.$t('List') + ' - ' + this.$t('Students')
				} else if (pageRole === 'parent') {
					return this.$t('List') + ' - ' + this.$t('Parents')
				}
			} else if (pageName === 'Dashboard Add') {
				if (pageRole === 'master franchise') {
					return this.$t('Create') + ' - ' + this.$t('Master Franchise')
				} else if (pageRole === 'franchise') {
					return this.$t('Create') + ' - ' + this.$t('Franchise')
				} else if (pageRole === 'teacher') {
					return this.$t('Create') + ' - ' + this.$t('Teacher')
				} else if (pageRole === 'group') {
					return this.$t('Create') + ' - ' + this.$t('Group')
				} else if (pageRole === 'student') {
					return this.$t('Create') + ' - ' + this.$t('Students')
				} else if (pageRole === 'parent') {
					return this.$t('Create') + ' - ' + this.$t('Parents')
				}
			} else if (
				this.$route.params.id === 'me' &&
				pageName === 'Dashboard Profile'
			) {
				return this.$t('My profile')
			} else if (pageName === 'Dashboard Settings') {
				return this.$t('Settings')
			} else if (pageName === 'Dashboard Profile') {
				return (
					this.$t('Profile') +
					' ' +
					this.$store.state.profile.first_name +
					' ' +
					this.$store.state.profile.last_name
				)
			} else if (pageName === 'Dashboard Group Profile') {
				return this.$t('Group') + ' - ' + this.$store.state.profile.name
			} else if (pageName === 'Dashboard Reports') {
				return this.$t('Finances')
			} else if (pageName === 'Dashboard FAQ') {
				return this.$t('FAQ')
			} else if (pageName === 'Dashboard Company') {
				return this.$t('Company')
			} else if (pageName === 'Dashboard About') {
				return this.$t('About Us')
			} else if (pageName === 'Dashboard Lessons') {
				return this.$t('Lessons')
			} else if (pageName === 'Dashboard Lesson') {
				return this.$t('Lesson')
			} else if (pageName === 'Dashboard Feedback') {
				return this.$t('Feedback')
			} else if (pageName === 'Dashboard Storage') {
				return this.$t('Materials')
			} else if (
				pageName === 'Profile Homework' ||
				pageName === 'Profile Homework Create' ||
				pageName === 'Group Homework' ||
				pageName === 'Group Homework Create'
			) {
				return `${this.$t('Homework')} - ${
					this.$store.state.homeworkProfileName
				}`
			}
			return ''
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.col-container {
	flex: 1;
	width: 100%;
	display: flex;

	align-items: center;
	justify-content: space-between;

	@media screen and (max-width: 750px) {
		flex-direction: column;
	}
}

.col-left {
	display: flex;
	align-items: center;

	text-align: center;
}

.col-center {
	flex: 1;
	text-align: center;
}

.col-center h2 {
	padding: 0;
}

.col-right {
	display: flex;
	align-items: center;
}

.btn-hover {
	min-height: 34px !important;
	transform: scale(1);
	transition: transform 0.25s ease-in-out;

	&:hover {
		transform: scale(1.05);
	}
}

.btn-menu {
	border: 1px solid #e6e9f3;
	color: #000;
	padding: 4px 10px;
	// margin-right: 24px;
	min-height: 32px;
	border-radius: 8px;
	outline: none !important;

	span {
		color: #000 !important;
		margin-left: 8px;
		font-size: 16px;
		line-height: 19px;
	}
}

.btn-back {
	margin-left: 24px;
	display: inline-flex;
	min-height: 32px;
	outline: none;
	padding: 4px 10px;
	border-radius: 8px;
	background-color: var(--violet-color);
	color: #fff;
	align-items: center;

	&:hover {
		color: #fff;
	}

	i {
		margin-right: 8px;
	}
}

.btn-language {
	// position: absolute;
	// top: 16px;
	// right: 126px;
	color: #333;
	font-size: 20px;
	display: block;
	z-index: 11;
}

.btn-language:hover {
	color: #e69c50;
}

#dashboard {
	overflow-x: hidden;
	position: relative;
	padding-left: 0;
}

#dashboard.toggled #dashboard-content {
	padding-left: 250px;
}

aside {
	z-index: 1000;
	position: fixed;
	left: 250px;
	width: 0;
	height: 100%;
	margin-left: -250px;
	padding-bottom: 1rem;
	overflow-y: auto;
	overflow-x: hidden;
	background: #fbfbfb;
	border-right: 2px solid #f0f0f0;
	-webkit-transition: all 0.2s;
	-moz-transition: all 0.2s;
	-o-transition: all 0.2s;
	transition: all 0.2s;
}

aside .logo {
	background-color: transparent;
	padding: 0;
	width: 100%;
	height: 100px;
	border: none;
	margin: 10px 0;
	outline: none;
}

aside .logo:hover,
aside .logo:active {
	background-color: transparent;
}

aside .logo img {
	max-height: 100%;
	width: auto;
}

aside a,
aside h4 {
	text-indent: 20px;
	line-height: 30px;
}

aside .loading {
	display: block;
	border: 1px solid transparent;
	padding-left: 0.75rem;
	padding-top: 0.375rem;
}

aside h4 {
	font-size: 16px;
	font-weight: normal !important;
	margin-bottom: 0;
	color: #333;
}

aside a {
	display: block;
	text-decoration: none;
	color: #719cd4;
	font-size: 18px;
	padding: 0 8px 0 20px;
	text-indent: 0;
}

aside a:hover {
	text-decoration: none;
	color: #e69c50;
}

aside a:active,
aside a:focus {
	text-decoration: none;
}

#dashboard aside span.new {
	font-weight: bold;
	color: #fff;
	background: #00b200;
	padding: 2px 4px;
	font-size: 13px;
	vertical-align: middle;
	border-radius: 8px;
}

#dashboard.toggled aside {
	width: 250px;
}

#dashboard-content {
	min-height: 100vh;
	position: relative;
	transition: all 0.5s ease;
	background-color: #fff;
}

.dashboard-header h2 {
	margin: 0;
	color: var(--violet-color);
	font-size: 24px;
	// padding-right: 94px;
}

.dashboard-header .row > div {
	padding: 0 15px;
}

#dashboard,
.dashboard-header .row > div {
	transition: all 0.5s ease;
}

.dashboard-header .row > div > * {
	vertical-align: middle;
}

.dashboard-header {
	padding: 15px 0;
	background: #ffffff;
	box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
}

.dashboard-header .user {
	margin-left: 20px;
	background-color: #e69c50;
	color: #fff;
	padding: 4px 10px;
	border-radius: 8px;
	min-height: 32px;
	display: inline-flex;
	align-items: center;

	&:hover {
		text-decoration: none;
	}

	svg {
		margin-right: 8px;
	}
}

.dashboard-header .mobile-panel .user {
	display: none;
}

#dashboard .scan .item {
	margin: 15px 0;
}

#dashboard .scan .actions {
	text-align: right;
}

#dashboard .scan .actions .btn {
	margin: 10px;
}

@media (min-width: 768px) and (max-width: 991px) {
	.dashboard-header h2 {
		font-size: 21px;
	}
}

@media (max-width: 767px) {
	#header {
		text-align: center;
	}

	.dashboard-header .row > div {
		width: 100%;
		margin-bottom: 15px;
	}

	.dashboard-header button {
		display: block;
		margin: 0;
	}

	.dashboard-header h2 {
		display: block;
		text-align: center;

		@media screen and (max-width: 750px) {
			margin-top: 20px;
			margin-bottom: 15px;
		}
	}

	#dashboard {
		padding-left: 0;
	}

	aside {
		width: 0;
	}

	aside .mobile-nav-button {
		display: block;
		color: #fff;
		font-size: 30px;
		text-align: right;
		padding-right: 15px;
	}

	#dashboard.toggled aside {
		width: 250px;
	}

	#dashboard-content {
		padding: 20px;
		position: relative;
	}

	.dashboard-header .mobile-panel .user {
		display: block;
	}

	.dashboard-header .mobile-panel h2 {
		width: 100%;
	}

	.dashboard-header .mobile-panel {
		display: block;
		// flex-wrap: wrap;
		justify-content: space-between;
	}

	.user-col {
		display: none;
	}
}

@media (max-width: 576px) {
	.offset-lg-1 > .btn {
		width: 100%;
		margin-bottom: 10px;
	}
}

@media (max-width: 480px) {
	#dashboard.toggled #dashboard-content {
		padding-left: 0px;
		left: 250px;
	}
}
</style>
